import { z } from 'zod';
export var SeatCampaignStatus;
(function (SeatCampaignStatus) {
    SeatCampaignStatus["Draft"] = "draft";
    SeatCampaignStatus["Active"] = "active";
    SeatCampaignStatus["Completed"] = "completed";
})(SeatCampaignStatus || (SeatCampaignStatus = {}));
// Create validation and DTO type
const seatCampaignCreateBaseSchema = z.object({
    name: z.string('Name is required').trim().min(1, 'Name is required'),
    description: z.string().trim().nullish(),
    meetingBodySeatTermIds: z.array(z.number()),
    startDate: z.iso.datetime('Start date is required'),
    submissionDeadline: z.iso.datetime('Submission deadline is required'),
    endDate: z.iso.datetime('End date is required'),
});
const seatCampaignCreateClientBaseSchema = seatCampaignCreateBaseSchema.extend({
    startDate: z.date('Start date is required'),
    submissionDeadline: z.date('Submission deadline is required'),
    endDate: z.date('End date is required'),
});
const refineEndDateAfterStartDate = (data) => new Date(data.startDate) < new Date(data.endDate);
const refineEndDateAfterStartDateMessage = {
    message: 'End date must be after start date',
    path: ['endDate'],
};
const refineSubmissionDeadlineAfterStartDate = (data) => new Date(data.startDate) < new Date(data.submissionDeadline);
const refineSubmissionDeadlineAfterStartDateMessage = {
    message: 'Submission deadline must be after start date',
    path: ['submissionDeadline'],
};
const refineEndDateAfterSubmissionDeadline = (data) => new Date(data.submissionDeadline) < new Date(data.endDate);
const refineEndDateAfterSubmissionDeadlineMessage = {
    message: 'End date must be after submission deadline',
    path: ['endDate'],
};
// Refinement functions for update schemas (handle optional fields)
const refineEndDateAfterStartDateUpdate = (data) => {
    if (data.startDate === undefined || data.endDate === undefined) {
        return true;
    }
    return new Date(data.startDate) < new Date(data.endDate);
};
const refineSubmissionDeadlineAfterStartDateUpdate = (data) => {
    if (data.startDate === undefined || data.submissionDeadline === undefined) {
        return true;
    }
    return new Date(data.startDate) < new Date(data.submissionDeadline);
};
const refineEndDateAfterSubmissionDeadlineUpdate = (data) => {
    if (data.submissionDeadline === undefined || data.endDate === undefined) {
        return true;
    }
    return new Date(data.submissionDeadline) < new Date(data.endDate);
};
// Create validation and DTO type
export const seatCampaignCreateSchema = seatCampaignCreateBaseSchema
    .refine(refineEndDateAfterStartDate, refineEndDateAfterStartDateMessage)
    .refine(refineSubmissionDeadlineAfterStartDate, refineSubmissionDeadlineAfterStartDateMessage)
    .refine(refineEndDateAfterSubmissionDeadline, refineEndDateAfterSubmissionDeadlineMessage);
export const seatCampaignCreateClientSchema = seatCampaignCreateClientBaseSchema
    .refine(refineEndDateAfterStartDate, refineEndDateAfterStartDateMessage)
    .refine(refineSubmissionDeadlineAfterStartDate, refineSubmissionDeadlineAfterStartDateMessage)
    .refine(refineEndDateAfterSubmissionDeadline, refineEndDateAfterSubmissionDeadlineMessage);
// Update validation and DTO type
export const seatCampaignUpdateSchema = seatCampaignCreateBaseSchema
    .partial()
    .refine(refineEndDateAfterStartDateUpdate, refineEndDateAfterStartDateMessage)
    .refine(refineSubmissionDeadlineAfterStartDateUpdate, refineSubmissionDeadlineAfterStartDateMessage)
    .refine(refineEndDateAfterSubmissionDeadlineUpdate, refineEndDateAfterSubmissionDeadlineMessage);
export const seatCampaignUpdateClientSchema = seatCampaignCreateClientBaseSchema
    .partial()
    .refine(refineEndDateAfterStartDateUpdate, refineEndDateAfterStartDateMessage)
    .refine(refineSubmissionDeadlineAfterStartDateUpdate, refineSubmissionDeadlineAfterStartDateMessage)
    .refine(refineEndDateAfterSubmissionDeadlineUpdate, refineEndDateAfterSubmissionDeadlineMessage);
